import { useEffect, useState } from "react";

// API
import {GetFeaturedSlider} from "../../Api/Sliders";

// Models
import {SliderDTO} from "../../Models/DTOs/SliderDTO";

function useFetchFeaturedSlider(sliderId: number | undefined, refresh: number) {
    const
        [slider, setSlider] = useState<SliderDTO | null>(null),
        [loading, setLoading] = useState(false),
        [error, setError] = useState("");

    useEffect(() => {
        let isCancelled = false;
        const controller = new AbortController();

        if (!sliderId) {
            setSlider(null);
            setError("");
            setLoading(false);
            return () => controller.abort();
        }

        setLoading(true);

        (async () => {
            try {
                const data = await GetFeaturedSlider(sliderId, controller);
                if (!isCancelled) setSlider(data);
            } catch (err) {
                if (!isCancelled) {
                    setError("Failed to fetch slider.");
                    console.error(err);
                }
            } finally {
                if (!isCancelled) setLoading(false);
            }
        })();

        return () => {
            isCancelled = true;
            controller.abort();
        };
    }, [sliderId, refresh]);

    return { slider, loading, error };
}

export default useFetchFeaturedSlider;
